module.exports = __webpack_public_path__ + "components/flag/static/square/xx-3542c193784ffc88bd73d4b70012c839.svg";